import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Redirect } from 'react-router-dom';
import { listProducts } from '../../../database/repositories/ProductRepository';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import ProductListHeading from '../../atoms/productlistheading';
import ProductListItems from '../../molecules/ProductListItems';
import Footer from '../../molecules/Footer';
import Box from '../../atoms/genericbox';
import Txt from '../../atoms/Txt';

function VendorProfile() {
  const [prodList, setProdList] = useState([]);

  const userData = useSelector((state) => state.auth.user_data);
  const profilePhotoUrl = useSelector((state) => state.auth.user_photo_url);

  useEffect(() => {
    listProducts().then(setProdList);
  }, []);

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <NavBar />
      <MainContent>
        <S.Content>
          <div className="vendor-profile-left-block">
            <div className="profile-img-wrapper">
              <img src={profilePhotoUrl} alt="Foto de Perfil" />
            </div>
            <h3>{userData ? userData.name : null}</h3>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
              <span>{userData ? userData.email : null}</span>
              <span
                style={{
                  margin: 10,
                  backgroundColor: '#ce1720',
                  borderRadius: 10,
                  paddingTop: 3,
                  paddingBottom: 3,
                  paddingLeft: 10,
                  paddingRight: 10,
                  color: '#fff'
                }}>
                VERIFICADO
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
              <strong>CPF/CNPJ</strong>
              <span>{userData ? userData.cpf : null}</span>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: 10
              }}>
              <strong>GÊNERO</strong>
              <span>Femimnino</span>
            </div>
          </div>
          <div className="vendor-profile-right-block">
            <div className="vendor-profile-right-top">
              <Box
                icon="fas fa-users"
                title="Usuário"
                style={{
                  flex: 0.5,
                  marginRight: 50,
                  height: 240
                }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    margin: 10
                  }}>
                  <i className="far fa-calendar-alt" style={{ fontSize: 60 }} />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      marginLeft: 20
                    }}>
                    <span
                      style={{
                        fontSize: 24,
                        fontWeight: 'bold'
                      }}>
                      KACARECANDO DESDE
                    </span>
                    <h1>
                      {userData ? new Date(userData.joinDate).toLocaleDateString('pt-br') : null}
                    </h1>
                  </div>
                </div>
              </Box>
              <Box
                icon="fas fa-home"
                title="Endereço"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 0.5,
                  height: 240
                }}>
                <Txt size={12}>{userData ? `${userData.addresses[0].address}, ` : ''} </Txt>
                <Txt size={12}>{userData ? `${userData.addresses[0].district}, ` : ''} </Txt>
                <Txt size={12}>{userData ? `${userData.addresses[0].city} - ` : ''} </Txt>
                <Txt size={12}>{userData ? userData.addresses[0].state : ''} </Txt>
                <Txt p size={12}>
                  {userData ? userData.addresses[0].zip : ''}{' '}
                </Txt>
                <Txt size={12}>{userData ? userData.addresses[0].complement : ''} </Txt>
              </Box>
            </div>
            <Box icon="fas fa-file-alt" title="Faturas">
              <table>
                <tr>
                  <th>Número</th>
                  <th>Data</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
                <tr>
                  <td>
                    <a href="/">0000004</a>
                  </td>
                  <td>03/08/2020</td>
                  <td>R$ 148,50</td>
                  <td style={{ color: '#ce1720' }}>Não Pago</td>
                  <td>
                    <button>VER MAIS {'>'}</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="/">0000003</a>
                  </td>
                  <td>03/07/2020</td>
                  <td>R$ 148,50</td>
                  <td style={{ color: '#ce1720' }}>Não Pago</td>
                  <td>
                    <button>VER MAIS {'>'}</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="/">0000002</a>
                  </td>
                  <td>02/06/2020</td>
                  <td>R$ 148,50</td>
                  <td style={{ color: '#00dd00' }}>Pago</td>
                  <td>
                    <button>VER MAIS {'>'}</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="/">0000001</a>
                  </td>
                  <td>09/05/2020</td>
                  <td>R$ 148,50</td>
                  <td style={{ color: '#00dd00' }}>Pago</td>
                  <td>
                    <button>VER MAIS {'>'}</button>
                  </td>
                </tr>
              </table>
              <div
                style={{
                  width: '100%',
                  fontWeight: 'bold',
                  textAlign: 'right',
                  color: '#a3a3a3',
                  textDecoration: 'underline'
                }}>
                Ver todos
              </div>
            </Box>
          </div>
        </S.Content>
        <ProductListHeading title="Anúncios recentes" side_link_to="/" side_link_txt="Ver Todos" />
        {prodList.length > 0 ? <ProductListItems items={prodList.slice(0, 4)} size="14pt" /> : null}
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default VendorProfile;
